import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Penguin(props: PresetArtProps) {
  return (
    <PresetFrame background="#0284c7" {...props}>
      <ellipse cx="32" cy="35" rx="15" ry="19" fill="#1f2937" />
      <ellipse cx="32" cy="39" rx="10" ry="14" fill="#ffffff" />
      <circle cx="27" cy="27" r="2.5" fill="#ffffff" />
      <circle cx="37" cy="27" r="2.5" fill="#ffffff" />
      <path d="M28 31 H36 L32 36 Z" fill="#f59e0b" />
    </PresetFrame>
  );
}
